var map = {
	"./flags/de.png": 1981,
	"./flags/en.png": 8229,
	"./flags/fr.png": 2712,
	"./logo.png": 3153,
	"./wordbook-text.png": 1071,
	"./wordbooklogo-image.png": 5062,
	"./wordbooklogo.png": 490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3138;